import styled from 'styled-components'
import { Columns } from 'components/flex'
import Link from 'components/link'
import { buttonStyles } from 'components/button'

export const HeroColumns = styled(Columns)`
    justify-content: space-between;
    align-items: center;
    column-gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
`

export const TitleColumns = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    column-gap: 16px;
`

export const ActionColumn = styled.div`
    position: relative;
`

export const PortalLink = styled(Link)`
    ${buttonStyles.ghostCss}

    &:is(:hover, :focus) {
        text-decoration: none;
    }
`